import React from 'react';
import { Clock, FileText, Wrench, Shield, Award, CheckCircle, Crosshair, MapPin } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: Clock,
    text: 'Same-Day Openings May Be Available'
  }, {
    icon: FileText,
    text: 'Free Auto Glass Estimates'
  }, {
    icon: Wrench,
    text: 'Certified Auto Glass Technicians'
  }, {
    icon: Shield,
    text: 'Works With Most Insurance'
  }, {
    icon: Award,
    text: 'Lifetime Workmanship Warranty'
  }, {
    icon: CheckCircle,
    text: 'OEM-Quality Glass'
  }, {
    icon: Crosshair,
    text: 'ADAS Calibration In-House'
  }, {
    icon: MapPin,
    text: 'Howell, Ann Arbor & Novi'
  }];
  return <div className="bg-slate-50 border-b border-slate-200 py-5 px-4 sm:px-6 lg:px-8" data-id="element-1173">
      <div className="max-w-7xl mx-auto" data-id="element-1174">
        <div className="flex flex-wrap justify-center gap-2.5 md:gap-3" data-id="element-1175">
          {items.map((item, i) => <div key={i} className="flex items-center gap-2 bg-white px-3.5 py-2 rounded-full border border-slate-200 shadow-sm" data-id="element-1176">
              <item.icon className="w-4 h-4 text-emergencyBrand-red" data-id="element-1177" />
              <span className="text-xs md:text-sm font-medium text-slate-700 whitespace-nowrap" data-id="element-1178">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}